import React from "react";
import "./index.css";
import Switch from "react-switch";

interface ToggleButtonProps {
  id?: string,
	className?: string,
  handleSwitchChange: any;
  checked: boolean;
  label?: string;
}

export function ToggleButton({
  id,
	className,
  handleSwitchChange,
  checked,
  label
}: ToggleButtonProps) {
  return (
    <label className={className}>
      {label && <span>{label}</span>}
      <Switch
          onChange={handleSwitchChange}
          checked={checked}
          uncheckedIcon={false}
          checkedIcon={false}
          className="react-switch"
          id={id}
          onColor="#92ade9"
          onHandleColor="#3367d6"
          handleDiameter={25}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={20}
          width={40}
      />
    </label>
  );
}

